import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import API from "../../../api";

export default function FurnitureAndFixture() {
  const { project } = useOutletContext();
  const projectId = project?._id;

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const formatINR = (num) =>
    Number(num)
      .toLocaleString("en-IN", { maximumFractionDigits: 2 })
      .padStart(1, "0");

  useEffect(() => {
    if (!projectId) {
      setLoading(false);
      return;
    }
    API.get(`/user/project-inputs/${projectId}`)
      .then(({ data }) => {
        const arr = Array.isArray(data.furnitureAndFixtures)
          ? data.furnitureAndFixtures
          : [];
        setRows(arr);
      })
      .catch((err) => {
        console.error("Failed to load Furniture & Fixtures:", err);
        if (err.response?.status === 404) {
          setRows([]);
        } else {
          setError("Unable to load data");
        }
      })
      .finally(() => setLoading(false));
  }, [projectId]);

  if (loading)
    return (
      <div className="flex h-64 items-center justify-center">
        <svg
          className="animate-spin h-10 w-10 text-gray-500"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          />
        </svg>
      </div>
    );

  if (error)
    return <div className="text-red-600 text-center py-8">{error}</div>;

  const totalAmount = rows.reduce((sum, r) => sum + (Number(r.amount) || 0), 0);

  return (
    <div className="bg-white">
      <div className="overflow-x-auto mb-8 shadow-lg rounded-lg">
        <table className="min-w-full table-auto border-collapse">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-2 py-1 border border-gray-200 text-left font-medium">
                Sl. No.
              </th>
              <th className="px-2 py-1 border border-gray-200 text-left font-medium">
                Particular
              </th>
              <th className="px-2 py-1 border border-gray-200 text-right font-medium">
                Amount (₹)
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={idx} className="even:bg-gray-50">
                <td className="px-2 py-1 border border-gray-200">{row.slNo}</td>
                <td className="px-2 py-1 border border-gray-200">
                  {row.particular}
                </td>
                <td className="px-2 py-1 border border-gray-200 text-right">
                  {formatINR(row.amount)}
                </td>
              </tr>
            ))}
            <tr className="bg-gray-200 font-bold">
              <td colSpan={2} className="px-2 py-1 border border-gray-200">
                Total
              </td>
              <td className="px-2 py-1 border border-gray-200 text-right">
                {totalAmount.toLocaleString("en-IN", {
                  maximumFractionDigits: 2,
                })}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
